const messagesES = {
    code: "es",
    messages: {
        included: (field) => `"${field}" Introduzca un valor válido en el campo`,
        url: (field) => `"${field}" el campo debe ser una URL válida`,
        alpha: (field) => `"${field}" solo puede contener letras`,
        alpha_dash: (field) => `"${field}" el campo puede contener letras y guiones (-) o guiones bajos (_)`,
        alpha_num: (field) => `"${field}" solo puede contener letras o numeros`,
        alpha_spaces: (field) => `"${field}" solo las letras pueden contener espacios`,
        between: (field, min, max) => `"${field}" ${min} con ${max} debe estar en el rango`,
        confirmed: (field, field2) => `"${field}" la verificación es incorrecta ${field2} Y ${field} debe ser lo mismo`,
        digits: (field, length) => `"${field}" numérico y ${length} debe ser escalonado`,
        dimensions: (field, width, height) => `"${field}" área ${width} con píxel ${height} debe estar entre píxeles`,
        email: (field) => `"${field}" El campo debe ser un correo electrónico válido`,
        excluded: (field) => `"${field}" no es un valor válido.`,
        ext: (field) => `"${field}" el campo debe ser un archivo válido`,
        image: (field) => `"${field}" el campo debe ser un archivo de imagen`,
        oneOf: (field) => `"${field}" Introduzca un valor válido en el campo`,
        max: (field, length) => `"${field}" área ${length} no más de un carácter`,
        max_value: (field, max) => `"${field}" área ${max} debe ser un valor de o menos`,
        mimes: (field) => `"${field}" debe ser un archivo valido`,
        min: (field, length) => `"${field}" área por lo menos ${length} se debe ingresar el caracter`,
        min_value: (field, min) => `"${field}" área ${min} debe ser un valor de o más`,
        numeric: (field) => `"${field}" Introduzca un valor numérico en el campo`,
        regex: (field) => `"${field}" el formato no es válido`,
        required: (field) => `"${field}" se requiere espacio`,
        required_if: (field) => `"${field}" se requiere espacio`,
        size: (field, size) => `"${field}" área ${size}Debe ser inferior a KB`,
        length: (field, len) => `"${field}" área ${len} el personaje debe ser`,
    },
};

export default messagesES;
